import React from 'react';
import styled from 'styled-components';

import { Footer, Button, GridContainer, Masthead, Promo, CTA, SubText, Paragraph } from '@agilytics/components';
import promos from './content.json';
import imgPromoTime from './img-promo-time.png';

const images = {
  imgPromoTime,
};

const Wrapper = styled.div`
  margin: 50px 0 150px 0;
`;

const Text = styled(Paragraph)`
  text-align: center;
  margin: auto;
`;
export default function Home() {
  return (
    <>
      <Masthead />
      <Wrapper>
        <GridContainer>
          {promos.map((promo, i) => (
            <Promo key={`promo-${i}`} {...promo} image={images[promo.image]} />
          ))}
          <CTA>
            <Button size="xl" to="/consent">
              get started
            </Button>
            <SubText>it only takes a few minutes. no sign-up required</SubText>
          </CTA>
          <Text>or</Text>
          <CTA>
            <Button size="l" to="/demo">
              try our demo
            </Button>
            <SubText>manually enter your throughput per day and try a forecast out</SubText>
          </CTA>
        </GridContainer>
      </Wrapper>
      <Footer />
    </>
  );
}
